import React, { Component } from 'react';
import { connect } from "react-redux";
import {VehicleDefault, MotorcycleDamage, MotorcycleDefault, Home, VehicleDamage, CalendarDefault, UserDefault, MediaDefault} from '../Common/Buttons/Icons';
import BookingRequestRow from './BookingRequestRow';
import UserRequestRow from './UserRequestRow';
import AlertMenuItem from './AlertMenuItem';
import VehicleReminderRow from './VehicleReminderRow';
import DamagedVehicleRow from './DamagedVehicleRow';
import OutstandingMediaRow from './OutstandingMediaRow';
import ReleaseReturnRow from './ReleaseReturnRow';
import EmptyState from '../Common/EmptyState.jsx';
import { Trans } from 'react-i18next';
import { FixedSizeList as List } from "react-window";

import Icon from '../Common/DesignSystem/Icons/Icon';
import colours from '../Common/DesignSystem/Colours';
import ReactTooltip from 'react-tooltip';
import { InLineLoading } from '../Common/Loading_Icon';

const Loading = () => (
    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '35px', height: '35px' }}>
            <InLineLoading />
        </div>
    </div>
)

//A React component will allow us to quickly iterate and change our code. It provides 
class AlertBar extends Component {
    constructor(props) {
        super(props);

        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.wrappedReleaseCheckInRow = this.wrappedReleaseCheckInRow.bind(this);
        this.wrappedOustandingMediaRow = this.wrappedOustandingMediaRow.bind(this);
        this.wrappedDamagedVehicleRow = this.wrappedDamagedVehicleRow.bind(this);
        this.goToCalendarPendingBookings = this.goToCalendarPendingBookings.bind(this);
    }

    componentDidUpdate() {
        ReactTooltip.rebuild();
    }

    toggleDropdown(id) {
        $('.dropdown-pane').removeClass('is-open');
    }

    onApproveHandler(e, props) {
    }

    onRejectHandler(e, props) {
    }

    wrappedReleaseCheckInRow({index, style}) {
        return (
            <div style={style}>
                <ReleaseReturnRow history={this.props.history} match={this.props.match} location={this.props.location} datatoggle="return-release-bookings-hover" key={"release_return_" + index} booking={this.props.data.return_release_bookings[index]} />
            </div>
        )
    }

    wrappedOustandingMediaRow({index, style}) {
        return (
            <div style={style}>
                <OutstandingMediaRow match={this.props.match} history={this.props.history} datatoggle="outstanding-media-hover" key={"outstanding_media_" + index} media={this.props.stakeholder.outstanding_media_list[index]} />
            </div>
        )
    }

    wrappedDamagedVehicleRow({index, style}) {
        return (
            <div style={style}>
                <DamagedVehicleRow match={this.props.match} history={this.props.history} datatoggle="damaged-vehicle-hover" key={"damaged_vehicle_" + index} vehicle={this.props.stakeholder.damaged_vehicle_list[index]} />
            </div>
        )
    }

    goToCalendarPendingBookings() {
        const redirectTo = 'bookings?filterBy=pendingBookings';
        this.props.history.push(redirectTo);
    }

    render() {
        return (
            <div className = "alert-bar fixed-navbar-page">

                <div onClick={this.goToCalendarPendingBookings}>
                    {/*Booking Request*/}

                    {/* <AlertMenuItem name="Booking Requests" icon={()=>Icon({name: 'Calendar', size: 24, class: 'primary', style: {margin: '0 auto'}})} count={this.props.stakeholder.booking_request_list.length} datatoggle="booking-request-hover" /> */}
                    <AlertMenuItem name="Booking Requests" icon={()=>Icon({name: 'Calendar', size: 24, class: 'primary', style: {margin: '0 auto'}})} count={this.props.stakeholder.booking_request_list.length} />

                    {/* <div className="dropdown-pane alert-pane" id="booking-request-hover"  data-h-offset = "11" style = {{left:"110px",top:"80px"}}>
                        <div className = "p-16 border-bottom">
                            <div className = "heading"><Trans>Booking Requests</Trans></div>
                        </div>
                        <div className = "alert-content-wrapper">
                        {
                            this.props.stakeholder?.booking_request_list?.length > 0 ?
                                this.props.stakeholder?.booking_request_list?.map((booking, i) =>
                                    <BookingRequestRow match={this.props.match} history={this.props.history} closeDropdown={()=> this.toggleDropdown()} datatoggle="booking-request-hover" booking={booking} key={"booking_request_" + i} onApproveHandler={this.onApproveHandler} onRejectHandler={this.onRejectHandler} />
                                )
                            : this.props.loading ?
                                <Loading />
                            :
                                <EmptyState image = "Calendar_Inactive.svg" text = "No Booking Requests" />
                        }
                        </div>
                    </div> */}
                </div>

                { this.props.page == "dashboard" ? (
                    <span>

                        {/*User Request*/}
                        <AlertMenuItem name = "User Requests" icon = {()=>Icon({name: 'User', size: 24, class: 'primary', style: {margin: '0 auto'}})} count={this.props.stakeholder.user_request_list.length} datatoggle="user-request-hover"/>
                        <div className = "dropdown-pane alert-pane" id="user-request-hover" data-h-offset = "11" style = {{left:"110px",top:"160px"}}>
                            <div className = "p-16 border-bottom">
                                <div className = "heading"><Trans>User Requests</Trans></div>
                            </div>
                            <div className = "alert-content-wrapper">
                            {
                                this.props.stakeholder.user_request_list?.length > 0 ?
                                    this.props.stakeholder.user_request_list.map((user_request, i) =>
                                        <UserRequestRow match={this.props.match} history={this.props.history} datatoggle="user-request-hover" key={"user_request_" + i} invite={user_request} />
                                    )
                                : this.props.loading ?
                                    <Loading />
                                :
                                    <EmptyState image = "User_Invited_Empty.svg" text = "No User Requests" />
                            }
                            </div>
                        </div>

                        {/*Vehicle Reminders*/}
                        {
                                <AlertMenuItem name = "Vehicle Reminders" icon = {()=>Icon({name: this.props.settings.vehicle_type == "motorcycles" ? 'Bike' : 'Car', size: 24, class: 'primary', style: {margin: '0 auto'}})} count={this.props.stakeholder.vehicle_reminder_list.length} datatoggle="veh-reminder-hover"/>
                        }
                        <div className = "dropdown-pane alert-pane" id="veh-reminder-hover" data-h-offset = "11" style = {{left:"110px",top:"140px"}}>
                            <div className = "p-16 border-bottom">
                                <div className = "heading"><Trans>Vehicle Reminders</Trans></div>
                            </div>
                            <div className = "alert-content-wrapper">
                            {
                                this.props.stakeholder.vehicle_reminder_list?.length > 0 ?
                                    this.props.stakeholder.vehicle_reminder_list.map((reminder, i) =>
                                        <VehicleReminderRow match={this.props.match} history={this.props.history} datatoggle="veh-reminder-hover" key={"vehicle_reminder_" + i} reminder={reminder} />
                                    )
                                : this.props.loading ?
                                    <Loading />
                                :
                                    <EmptyState image = "Vehicle_Reminder_Empty.svg" text = "No Vehicle Reminders" />
                            }
                            </div>
                        </div>

                        {/*Vehicle Damaged*/}
                        {
                            <AlertMenuItem name = "Damaged Vehicles" icon = {()=>Icon({name: this.props.settings.vehicle_type == "motorcycles" ? 'Bike' : 'CarDamage', size: 24, class: 'primary', style: {margin: '0 auto'}})} count={this.props.stakeholder.damaged_vehicle_list.length} datatoggle="damaged-vehicle-hover"/>
                        }
                        <div className = "dropdown-pane alert-pane" id="damaged-vehicle-hover" data-h-offset = "11" style = {{left:"110px",top:"230px"}}>
                            <div className = "p-16 border-bottom">
                                <div className = "heading"><Trans>Damaged Vehicles</Trans></div>
                            </div>
                            <div className = "alert-content-wrapper">
                            {
                                this.props.stakeholder.damaged_vehicle_list.length > 0 ?
                                    <List
                                        width={698}
                                        height={350}
                                        itemCount={this.props.stakeholder.damaged_vehicle_list.length}
                                        itemSize={83}
                                    >
                                        {this.wrappedDamagedVehicleRow}
                                    </List>
                                : this.props.loading ?
                                    <Loading />
                                :
                                    <EmptyState image = {this.props.settings.images.vehicle_placeholder_empty} text = "No Damaged Vehicles"/>
                            }
                            </div>
                        </div>

                        {/*Outstanding Media*/}
                        {
                            this.props.userSession.user.has_media_components ?
                                <AlertMenuItem name = "Outstanding Media" icon = {()=>Icon({name: 'Media', size: 24, class: 'primary', style: {margin: '0 auto'}})} count={this.props.stakeholder.outstanding_media_list? this.props.stakeholder.outstanding_media_list.length : 0} datatoggle="outstanding-media-hover"/>
                            :
                                null
                        }
                        {
                            this.props.userSession.user.has_media_components ?
                                <div className = "dropdown-pane alert-pane" id="outstanding-media-hover" data-h-offset = "11" style = {{left:"110px",top:"215px"}}>
                                    <div className = "p-16 border-bottom">
                                        <div className = "heading"><Trans>Outstanding Media</Trans></div>
                                    </div>
                                    <div className = "alert-content-wrapper">
                                    {
                                        !this.props.loading && this.props.stakeholder.outstanding_media_list?.length > 0 ?
                                            <List
                                                width={698}
                                                height={350}
                                                itemCount={this.props.stakeholder.outstanding_media_list.length}
                                                itemSize={106}
                                            >
                                                {this.wrappedOustandingMediaRow}
                                            </List>
                                        : this.props.loading ?
                                            <Loading />
                                        :
                                            <EmptyState image = "Media_Inactive.svg" text = "No Outstanding Media"/>
                                    }
                                    </div>
                                </div>
                            :
                                null
                        }
                    </span>
                    ) : (
                        <span></span>
                )}

                { this.props.page == "bookings" ?
                        <span>
                            {/*Release & Check In*/}
                            <AlertMenuItem name = "Release & Check In" icon = {()=>Home("fill-primary")} count={this.props.data.return_release_bookings.length} datatoggle="return-release-bookings-hover"/>
                            <div className = "dropdown-pane alert-pane" id="return-release-bookings-hover" data-h-offset = "11" style = {{left:"110px",top:"160px"}}>
                                <div className = "p-16 border-bottom">
                                    <div className = "heading"><Trans>Release & Check In</Trans></div>
                                </div>
                                <div className = "alert-content-wrapper">
                                {
                                    !this.props.loading && this.props.data.return_release_bookings?.length > 0 ?
                                        <List
                                            width={698}
                                            height={350}
                                            itemCount={this.props.data.return_release_bookings.length}
                                            itemSize={127}
                                        >
                                        {/* this.props.data.return_release_bookings.map((booking, i) => */}
                                            {this.wrappedReleaseCheckInRow}
                                        {/* ) */}
                                        </List>
                                    : this.props.loading ?
                                        <Loading />
                                    :
                                        <EmptyState image = {this.props.settings.images.vehicle_placeholder_empty} text = "No Release Or Check Ins"/>
                                }
                                </div>
                            </div>
                        </span>
                    :
                    <span></span>
                }                    
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder,
    settings: store.settings
});

export default connect(mapStateToProps)(AlertBar);